import { render, staticRenderFns } from "./ContentCustomBox.vue?vue&type=template&id=93274f9c&"
import script from "./ContentCustomBox.vue?vue&type=script&lang=js&"
export * from "./ContentCustomBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports